// extracted by mini-css-extract-plugin
module.exports = {"adInspectorWrapper":"ad-inspector_adInspectorWrapper__Gv0ev","warningMessage":"ad-inspector_warningMessage__R7Gsk"};